import './providers.scss';
import React from 'react';
import { T } from 'shared/helper/translate';
import { parseQueryParams } from 'shared/helper/link-helper';
import { getApiBaseUrl } from 'shared/helper/request';
import WeChatLogin from './WeChatLogin';
var Providers = function Providers(_ref) {
  var _parseQueryParams$ori;
  var providers = _ref.providers,
    referringUrl = _ref.referringUrl;
  if (providers.length === 0) {
    return null;
  }
  var weChatSrc = providers.find(function (val) {
    return val.id === 'wechat';
  }).img;
  var origin = (_parseQueryParams$ori = parseQueryParams(window.location.search).origin) !== null && _parseQueryParams$ori !== void 0 ? _parseQueryParams$ori : '';
  var params = "?redirect=".concat(referringUrl && referringUrl.startsWith('http') ? referringUrl : window.location.origin + (referringUrl || '/'));
  params = origin ? params.concat(params.length > 0 ? '&' : '?', "origin=".concat(origin)) : params;
  return /*#__PURE__*/React.createElement("div", null, providers.map(function (provider) {
    return provider.id !== 'wechat' && /*#__PURE__*/React.createElement("div", {
      key: provider.id
    }, /*#__PURE__*/React.createElement("a", {
      href: "".concat(getApiBaseUrl(), "/api/auth/opa/").concat(provider.id).concat(params)
    }, /*#__PURE__*/React.createElement("div", {
      className: "social-login py-2 w-100"
    }, /*#__PURE__*/React.createElement("img", {
      alt: "Sign up with ".concat(provider.name),
      src: provider.img,
      height: "20"
    }), /*#__PURE__*/React.createElement("span", {
      className: "provider-icon-spacer"
    }), /*#__PURE__*/React.createElement(T, {
      source: "sign-in-with"
    }), " ", provider.name)));
  }), /*#__PURE__*/React.createElement(WeChatLogin, {
    source: "sign-in-with",
    className: "social-login py-2 w-100 text-center",
    isInLogin: true,
    img: weChatSrc
  }));
};
export default Providers;